import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import * as i1 from '@angular/common/http';
import * as i2 from '@angular/forms';
import { FormGroup, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as moment from 'moment';
import * as i3 from 'primeng/dropdown';
import * as i4 from '@angular/common';
import * as i5 from 'primeng/inputnumber';
import * as i6 from 'primeng/calendar';
import { PrimengLibraryModule } from 'primeng-library';

class LibProjectTypeService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getProjectType(dataSourceType) {
        var encryptedText = this.toEncrypt(dataSourceType);
        return this.http.get(`/vd/dataSource/${encryptedText}/elements`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
LibProjectTypeService.ɵfac = function LibProjectTypeService_Factory(t) { return new (t || LibProjectTypeService)(i0.ɵɵinject(i1.HttpClient)); };
LibProjectTypeService.ɵprov = i0.ɵɵdefineInjectable({ token: LibProjectTypeService, factory: LibProjectTypeService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibProjectTypeService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function LibProjectTypeComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "label", 7);
    i0.ɵɵtext(3, "Time Estimation Hours");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelement(5, "p-inputNumber", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("min", 0)("max", 10000);
} }
function LibProjectTypeComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelementStart(2, "label", 9);
    i0.ɵɵtext(3, "Project Start Date ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "p-calendar", 10);
    i0.ɵɵlistener("onSelect", function LibProjectTypeComponent_ng_container_7_Template_p_calendar_onSelect_5_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.startDateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 6);
    i0.ɵɵelementStart(7, "label", 11);
    i0.ɵɵtext(8, "Project End Date ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(9, "br");
    i0.ɵɵelementStart(10, "p-calendar", 12);
    i0.ɵɵlistener("onSelect", function LibProjectTypeComponent_ng_container_7_Template_p_calendar_onSelect_10_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.endDateChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("showIcon", true);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("minDate", ctx_r1.setEndDateFieldVal)("showIcon", true);
} }
class LibProjectTypeComponent {
    constructor(projectTypeService) {
        this.projectTypeService = projectTypeService;
        this.group = new FormGroup({});
        this.observableSubscription$ = new Subject();
        this.projectTypeDetails = [];
        this.projectTypeParam = "PROJECTTYPE";
    }
    ngOnInit() {
        let projectTypeName = null;
        let projectType = null;
        let startDate = this.inputParams.value && this.inputParams.value.startDate ? this.inputParams.value.startDate : null;
        let endDate = this.inputParams.value && this.inputParams.value.endDate ? this.inputParams.value.endDate : null;
        let hours = this.inputParams.value && this.inputParams.value.hours ? this.inputParams.value.hours : null;
        let projectTypeId = this.inputParams.value && this.inputParams.value.projectTypeId ? this.inputParams.value.projectTypeId : null;
        if (this.inputParams.value && this.inputParams.value.projectType) {
            projectType = this.inputParams.value.projectType[0];
            projectTypeName = projectType ? projectType.id : null;
        }
        if (projectTypeId == 1906) {
            this.enableTimeBased = false;
        }
        else if (projectTypeId == 1905) {
            this.enableTimeBased = true;
        }
        this.group.addControl(this.inputParams.name, new FormGroup({
            projectType: new FormControl(projectType),
            hours: new FormControl(hours),
            startDate: new FormControl(startDate),
            endDate: new FormControl(endDate),
            projectTypeId: new FormControl(projectTypeId),
            projectTypeName: new FormControl(projectTypeName),
        }));
        this.getProjectTypeDetails();
    }
    getProjectTypeDetails() {
        this.projectTypeService.getProjectType(this.projectTypeParam).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
            this.projectTypeDetails = response.data || null;
        });
    }
    onChangeProject(data) {
        let type = this.projectTypeDetails.filter(x => x.id == data.value);
        this.group.controls[this.inputParams.name].patchValue({
            projectType: type
        });
        this.group.controls[this.inputParams.name].patchValue({
            projectTypeId: data.value
        });
        if (data.value == 1906) {
            this.enableTimeBased = false;
        }
        else {
            this.enableTimeBased = true;
        }
        this.group.controls[this.inputParams.name].patchValue({
            projectTypeName: type[0].id
        });
    }
    startDateChange(event) {
        this.setEndDateFieldVal = event;
        let setDate = moment(event).format("MM/DD/YYYY");
        this.group.controls[this.inputParams.name].patchValue({
            startDate: setDate
        });
    }
    endDateChange(event) {
        let setDate = moment(event).format("MM/DD/YYYY");
        this.group.controls[this.inputParams.name].patchValue({
            endDate: setDate
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
LibProjectTypeComponent.ɵfac = function LibProjectTypeComponent_Factory(t) { return new (t || LibProjectTypeComponent)(i0.ɵɵdirectiveInject(LibProjectTypeService)); };
LibProjectTypeComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibProjectTypeComponent, selectors: [["lib-project-type"]], inputs: { inputParams: "inputParams", group: "group", formControlName: "formControlName" }, decls: 8, vars: 5, consts: [[1, "container-fluid", "p-0", "mt-2", "mb-2", "pb-3", 3, "formGroup"], [1, "row", 3, "formGroupName"], [1, "col-4", "pl-0"], ["for", "projectType", 1, "create-task-label"], ["appendTo", "body", "name", "projectType", "placeholder", "Select Project Type", "formControlName", "projectTypeName", "optionLabel", "name", "optionValue", "id", 1, "w-100", 3, "options", "onChange"], [4, "ngIf"], [1, "col-4"], [1, "create-task-label"], ["inputId", "integeronly", "appendTo", "body", "placeholder", "Enter hours", "formControlName", "hours", 3, "min", "max"], ["for", "startDate", 1, "create-task-label"], ["id", "startDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "startDate", "showIcon", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "startDate", 1, "im-input-calendar", "mw-100", 3, "showIcon", "onSelect"], ["for", "endDate", 1, "create-task-label"], ["id", "endDate", "yearRange", "1900:2100", "appendTo", "body", "type", "text", "yearNavigator", "true", "monthNavigator", "true", "formControlName", "endDate", "showIcon", "true", "inputId", "icon", "dateFormat", "mm/dd/yy", "placeholder", "MM/DD/YY", "name", "endDate", 1, "im-input-calendar", "mw-100", 3, "minDate", "showIcon", "onSelect"]], template: function LibProjectTypeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "label", 3);
        i0.ɵɵtext(4, "Project Type");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "p-dropdown", 4);
        i0.ɵɵlistener("onChange", function LibProjectTypeComponent_Template_p_dropdown_onChange_5_listener($event) { return ctx.onChangeProject($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, LibProjectTypeComponent_ng_container_6_Template, 6, 2, "ng-container", 5);
        i0.ɵɵtemplate(7, LibProjectTypeComponent_ng_container_7_Template, 11, 3, "ng-container", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroupName", ctx.formControlName);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.projectTypeDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.enableTimeBased && ctx.enableTimeBased !== undefined);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.enableTimeBased && ctx.enableTimeBased !== undefined);
    } }, directives: [i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormGroupName, i3.Dropdown, i2.NgControlStatus, i2.FormControlName, i4.NgIf, i5.InputNumber, i6.Calendar], styles: [".create-task-label[_ngcontent-%COMP%]{margin-bottom:0}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibProjectTypeComponent, [{
        type: Component,
        args: [{
                selector: 'lib-project-type',
                templateUrl: 'lib-project-type.component.html',
                styleUrls: ['lib-project-type.component.scss']
            }]
    }], function () { return [{ type: LibProjectTypeService }]; }, { inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }], formControlName: [{
            type: Input
        }] }); })();

class LibProjectTypeModule {
}
LibProjectTypeModule.ɵfac = function LibProjectTypeModule_Factory(t) { return new (t || LibProjectTypeModule)(); };
LibProjectTypeModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibProjectTypeModule });
LibProjectTypeModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibProjectTypeModule, { declarations: [LibProjectTypeComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule], exports: [LibProjectTypeComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibProjectTypeModule, [{
        type: NgModule,
        args: [{
                declarations: [LibProjectTypeComponent],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                exports: [LibProjectTypeComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-project-type
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibProjectTypeComponent, LibProjectTypeModule, LibProjectTypeService };
//# sourceMappingURL=lib-project-type.js.map
